import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import { Card, CardBody } from "reactstrap"
import LeadForm from "./LeadForm"
import Swal from "sweetalert2"
import {
  fetchData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import Configs from "../../config"
import Loader from "components/Loader/Loader"

const EditLead = () => {
  document.title = "Edit Lead | Vintage Infra Equipment Sol PVT LTD"
  const { id } = useParams()

  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  const [formData, setFormData] = useState({})
  const [users, setUsers] = useState([])
  const [leadSources, setLeadSources] = useState([])

  useEffect(() => {
    if (id) {
      fetchLeadData()
      fetchUsers()
    }
  }, [id])

  async function fetchLeadData() {
    const APIdata = await fetchData(setLoading, `leads/${id}`)
    if (APIdata?.success) {
      setFormData(APIdata?.data)
    }
  }

  async function fetchUsers() {
    const APIdata = await fetchData(setLoading, "users")
    if (APIdata?.success) {
      setUsers(APIdata?.data.filter(user => user.status))
    }
    const APIdata1 = await fetchData(setLoading, "lead-source")
    if (APIdata1?.success) {
      setLeadSources(APIdata1?.data)
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    const APIdata = await FetchPutData(
      setLoading,
      "leads",
      formData?.id,
      formData
    )
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Lead Updated Successfully",
        text: APIdata?.data?.message,
        icon: "success",
      })
      navigate(`${Configs.appurl}leads`)
    } else {
      Swal.fire({
        title: "Error Updating Lead",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <div className="page-content">
      <Breadcrumb title="Leads Management" breadcrumbItem="Edit Lead" />
      {loading && <Loader />}
      <LeadForm
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleSubmit}
        leadSources={leadSources}
        users={users}
      />
    </div>
  )
}

export default EditLead
